import { Tabs } from "@ubnt/ui-components/Tabs";
import styled from "styled-components";

export const StyledTabs = styled(Tabs)`
  .tabs {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #dee0e3;
  }

  .tab {
    padding: 4px 16px;

    > span {
      display: flex;
      align-items: center;
      color: #676f79;

      svg {
        bottom: 0;
        color: #808893;
        transition: color 0.15s linear;
      }
    }

    &:hover:not(.selected-tab) {
      > span {
        color: ${({ theme }) => theme.colors.primaryBlue} !important;

        svg {
          color: ${({ theme }) => theme.colors.primaryBlue};
        }
      }
    }
  }

  .selected-tab {
    background: ${({ theme }) => theme.colors.primaryBlue} !important;

    > span {
      color: ${({ theme }) => theme.colors.white} !important;

      svg {
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
